var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","rules":_vm.rules,"label":_vm.$t('configurations.report_duration')},model:{value:(_vm.duration),callback:function ($$v) {_vm.duration=$$v},expression:"duration"}})}
var staticRenderFns = []

export { render, staticRenderFns }